import React from 'react';

class SectionHeader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            aboutUs : 'About Us',
            instaGram : 'Instagram'
        }
    }

    render(){
        return (
          <div className="section-header">
            <h2>{this.state.aboutUs}</h2>
          </div>
        )
    }
}

export default SectionHeader


// WEBPACK FOOTER //
// ./src/components/container/SectionHeader.js